import IconButton from '@ixigo/iui/IconButton';
import Typography from '@ixigo/iui/Typography';

export interface LocationLabelProps {
	/** The location address text */
	label: string;
	/** Custom class name */
	className?: string;
	/** Action icon */
	actionIcon?: React.ReactNode;
	/** Action handler */
	actionHandler?: () => void;
}

export function LocationLabel({
	label,
	className,
	actionIcon,
	actionHandler,
}: LocationLabelProps) {
	return (
		<div className="flex items-center justify-between line-clamp-1 gap-x-10">
			<Typography
				variant="body-sm"
				className={`overflow-hidden text-ellipsis ${className}`}
			>
				{label}
			</Typography>
			{actionIcon && (
				<IconButton
					onClick={actionHandler}
					color="neutral"
					className="!min-h-0 text-secondary border-none"
				>
					{actionIcon}
				</IconButton>
			)}
		</div>
	);
}

export default LocationLabel;
